var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApiFirstGal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 11,
    viewBox: "0 0 16 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.7276 8.2737L14.0004 0L15.2739 1.2726L5.7276 10.8189L0 5.0913L1.2726 3.8187L5.7276 8.2737Z",
    fill: "#1FC16B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApiFirstGal);
export default __webpack_public_path__ + "static/media/api_first_gal.a96b28be6caabcea09c9d4f315c0f416.svg";
export { ForwardRef as ReactComponent };